import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { SalesCounterpartTypeaheadSkeleton } from 'components/shared/SalesCounterpartTypeahead/SalesCounterpartTypeAhead';
import { SalesCounterpartTypeahead } from 'components/shared/SalesCounterpartTypeahead/SalesCounterpartTypeAhead.withFilterApi';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { useExistsValidationErrorFor } from '../ValidationErrorsContext';

interface OwnProps {
  selectedOnBehalfClient: ISalesCounterpart | null;
  isDisabled?: boolean;
  onChange: (newClient: ISalesCounterpart | null) => void;
}
export const SalesCounterpart: FC<OwnProps> = ({ selectedOnBehalfClient, isDisabled, onChange }) => {
  const { isLoading } = useContext(AddonMainFormContext);
  const hasErrors = useExistsValidationErrorFor('salesCounterpart');
  return (
    <BlockOrientationFormGroup inputId="salesCounterpart" label="salesCounterpart">
      {!isLoading && (
        <SalesCounterpartTypeahead
          id="salesCounterpart"
          e2e="addon-investment-details-salescounterpart"
          selectedItem={selectedOnBehalfClient}
          onSelectedItemChanged={newClient => {
            onChange(newClient);
          }}
          isDisabled={isDisabled}
          hasErrors={hasErrors}
        />
      )}
      {isLoading && <SalesCounterpartTypeaheadSkeleton />}
    </BlockOrientationFormGroup>
  );
};
